module.exports = __webpack_public_path__ + "static/media/icon-trash.7eeb6f98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/my-account/icon-trash.svg
// module id = 158
// module chunks = 0 1 2